export const GET_TYREWIDTHS_STATED = "GET_TYREWIDTHS_STATED";
export const GET_TYREWIDTHS = "GET_TYREWIDTHS";
export const GET_TYREWIDTHS_ENDED = "GET_TYREWIDTHS_ENDED";
export const ADD_TYREWIDTH_STATED = "ADD_TYREWIDTH_STARTED";
export const ADD_TYREWIDTH = "ADD_TYREWIDTH";
export const ADD_TYREWIDTH_ENDED = "ADD_TYREWIDTH_ENDED";
export const EDIT_TYREWIDTH_STATED = "EDIT_TYREWIDTH_STATED";
export const EDIT_TYREWIDTH = "EDIT_TYREWIDTH";
export const EDIT_TYREWIDTH_ENDED = "EDIT_TYREWIDTH_ENDED";
export const GET_TYREWIDTH = "GET_TYREWIDTH";
export const GET_TYREWIDTH_STATED = "GET_TYREWIDTH_STATED";
export const GET_TYREWIDTH_ENDED = "GET_TYREWIDTH_ENDED";
export const RESET_TYREWIDTH = "RESET_TYREWIDTH";
export const ERROR_TYREWIDTH = "ERROR_TYREWIDTH";
export const GET_ALL_TYREWIDTHS_STATED = "GET_ALL_TYREWIDTHS_STATED";
export const GET_ALL_TYREWIDTHS = "GET_ALL_TYREWIDTHS";
export const GET_ALL_TYREWIDTHS_ENDED = "GET_ALL_TYREWIDTHS_ENDED";
